"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CornerUpIcon = void 0;
/* eslint-disable max-len */
var react_1 = __importStar(require("react"));
var Icon_1 = require("./Icon");
exports.CornerUpIcon = (0, react_1.forwardRef)(function CornerUpIcon(props, ref) {
    return (react_1.default.createElement(Icon_1.Icon, __assign({ ref: ref, width: "24", height: "24", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
        react_1.default.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M16.9499 15.3298C17.1374 15.1423 17.2427 14.888 17.2427 14.6228C17.2427 14.3577 17.1374 14.1034 16.9499 13.9158L12.7069 9.67284C12.5194 9.48537 12.2651 9.38006 11.9999 9.38006C11.7347 9.38006 11.4804 9.48537 11.2929 9.67284L7.04989 13.9158C6.95704 14.0088 6.88341 14.119 6.83319 14.2404C6.78296 14.3618 6.75714 14.4918 6.75719 14.6232C6.75723 14.7545 6.78315 14.8846 6.83346 15.0059C6.88377 15.1273 6.95748 15.2375 7.05039 15.3303C7.1433 15.4232 7.25359 15.4968 7.37496 15.547C7.49632 15.5973 7.62639 15.6231 7.75774 15.623C7.88909 15.623 8.01915 15.5971 8.14048 15.5468C8.26181 15.4965 8.37204 15.4228 8.46489 15.3298L11.9999 11.7948L15.5359 15.3298C15.7234 15.5173 15.9777 15.6226 16.2429 15.6226C16.5081 15.6226 16.7624 15.5173 16.9499 15.3298Z", fill: "currentColor" })));
});
